const styles = {
  page: {
    width: "100%",
    maxWidth: 760,
    mx: "auto",
  },
  section: {
    border: "1px solid rgba(1,67,57,0.12)",
    borderRadius: "14px",
    bgcolor: "#fff",
    p: { xs: 2, md: 2.5 },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1.5,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "primary.main",
  },
  editButton: {
    textTransform: "none",
    fontSize: 12,
    color: "purple.dark",
    minWidth: 0,
  },
  linkButton: {
    textTransform: "none",
    fontSize: 13,
    color: "purple.dark",
    p: 0,
    minWidth: 0,
  },
  detailFields: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  detailRow: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: 2,
  },
  recommendedChip: {
    ml: 1,
    fontSize: 11,
    fontWeight: 600,
    height: 20,
    bgcolor: "purple.light",
    color: "purple.dark",
  },
  compose: {
    border: "1px solid",
    borderColor: "grey.300",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  composeBar: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 1,
    bgcolor: "grey.100",
    borderBottom: "1px solid",
    borderColor: "grey.200",
  },
  composeRow: {
    display: "flex",
    gap: 1.5,
    px: 2,
    py: 1,
    borderBottom: "1px solid",
    borderColor: "grey.100",
  },
  composeLabel: {
    fontSize: 13,
    color: "text.secondary",
    width: 56,
    flexShrink: 0,
  },
  composeValue: {
    fontSize: 13,
    color: "text.primary",
    minWidth: 0,
  },
  composeBody: {
    px: 2,
    py: 1.5,
    fontSize: 14,
    lineHeight: 1.7,
    color: "rgba(0,0,0,0.8)",
    "& a": { color: "#2563eb" },
  },
  followupChip: {
    ml: "auto",
    fontSize: 11,
    fontWeight: 600,
    bgcolor: "rgba(177,179,248,0.25)",
    color: "purple.dark",
  },
  emailTabs: {
    display: "flex",
    gap: 1,
    mb: 1.5,
    flexWrap: "wrap",
  },
  emailTab: (active: boolean) => ({
    px: 1.5,
    py: 0.5,
    borderRadius: "8px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    border: "1px solid",
    borderColor: active ? "primary.main" : "grey.300",
    color: active ? "primary.main" : "text.secondary",
    bgcolor: active ? "rgba(1,67,57,0.04)" : "transparent",
  }),
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: 700,
  },
};

export default styles;
